import React, { memo, useCallback, useEffect } from 'react';

import { isEmptyObject } from '@Sage/ssm-utils';
import { useDispatch, useSelector } from 'react-redux';

import { BillboardActions, EntityDetailActions } from 'actions';
import Scrollbar from 'components/ScrollBar';
import TreeNode from 'components/TreeNavigatorNew/TreeNode';
import { BILLBOARD } from 'constants/Entities';

const BillboardContentNavigator = memo(() => {
    const dispatch = useDispatch();
    const { published, selectedPublished, received, selectedReceived } = useSelector((state) => ({
        published: state.billboard.menu.published || null,
        selectedPublished: state.billboard.menu.selectedPublished || null,
        received: state.billboard.menu.received || null,
        selectedReceived: state.billboard.menu.selectedReceived || null,
    }));

    useEffect(() => {
        dispatch(BillboardActions.getBillboardMenu());
        dispatch(BillboardActions.selectReceived('root', true));
    }, [dispatch]);

    const closeDetail = useCallback(() => {
        dispatch(EntityDetailActions.close());
    }, [dispatch]);

    const selectPublished = useCallback(
        (object) => {
            if (selectedReceived) {
                closeDetail();
            }
            dispatch(BillboardActions.selectPublished(object.node.id));
        },
        [closeDetail, dispatch, selectedReceived],
    );

    const selectReceived = useCallback(
        (object) => {
            if (selectedPublished) {
                closeDetail();
            }
            dispatch(BillboardActions.selectReceived(object.node.id));
        },
        [closeDetail, dispatch, selectedPublished],
    );

    return (
        <div className="billboard-navigator">
            <Scrollbar>
                {!isEmptyObject(published) && (
                    <TreeNode
                        entityType={BILLBOARD}
                        depth={0}
                        folderSelectedId={selectedPublished}
                        dataSource={published}
                        node_id="root"
                        colorIconSelected="fmTurquoise"
                        iconType="folder"
                        openRootFolder={true}
                        onClickNode={selectPublished}
                    />
                )}
                {!isEmptyObject(received) && (
                    <TreeNode
                        entityType={BILLBOARD}
                        depth={0}
                        folderSelectedId={selectedReceived}
                        dataSource={received}
                        node_id="root"
                        colorIconSelected="fmTurquoise"
                        iconType="folder"
                        openRootFolder={true}
                        onClickNode={selectReceived}
                    />
                )}
            </Scrollbar>
        </div>
    );
});

export default BillboardContentNavigator;
